import { render, staticRenderFns } from "./UpLoadingView.vue?vue&type=template&id=289aad33&scoped=true&"
import script from "./UpLoadingView.vue?vue&type=script&lang=js&"
export * from "./UpLoadingView.vue?vue&type=script&lang=js&"
import style0 from "./UpLoadingView.vue?vue&type=style&index=0&id=289aad33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289aad33",
  null
  
)

export default component.exports